/**
 * Global Imports
*/

import React from 'react';

/**
 * Root Imports
*/

import * as UserServices from '~/services/User';
import { ResourcesProvider } from '~/components/Provider';

/**
 * Exports
*/

export const UserContext = React.createContext({});

/**
 * 
 */
export function UserProvider(props) {
  return (
    <ResourcesProvider name='User' context={ UserContext } services={ UserServices }>
      { props.children }
    </ResourcesProvider>
  );
}